module.exports = __webpack_public_path__ + "static/3-754ef3f3864ef1235dbcc2070bb6d18e.jpg";